import { render, staticRenderFns } from "./RightBox3.vue?vue&type=template&id=ed77a05e&scoped=true"
import script from "./RightBox3.vue?vue&type=script&lang=js"
export * from "./RightBox3.vue?vue&type=script&lang=js"
import style0 from "./RightBox3.vue?vue&type=style&index=0&id=ed77a05e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed77a05e",
  null
  
)

export default component.exports